import React, { useState, useEffect, useContext } from "react"
import { Outlet, useParams, useLocation, useNavigate } from "react-router-dom"
import plmLogo from "@/assets/plm-logo-w.png"
import { PlmContext, GlobalContext } from "@/contexts"
import type { ProjectProps } from "@/halSources"
import { documentUtil, isIthClient } from "@/utils"
import { ConfigProvider } from "antd"
import { isDev } from "@/config/common"

export const PpmLayout = () => {
  const navigate = useNavigate()
  const { projectID } = useParams()
  const location = useLocation()
  const [currentProject, setCurrentProject] = useState<
    ProjectProps | undefined
  >()

  const { user } = useContext(GlobalContext)

  useEffect(() => {
    if (!projectID) {
      setCurrentProject(undefined)
    }
  }, [location, projectID])

  const onChangeUser = () => {
    if (isDev) {
      navigate("/auth/jwt")
    } else {
      const url = new URL(
        "/workbenchApi/auth/sso-login",
        window.location.origin
      )
      url.searchParams.append("redirect_uri", window.location.href)
      window.location.href = url.href
    }
  }

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#1f1547",
        },
        components: {
          Layout: {
            headerBg: "#FFFFFF",
          },
          Table: {
            headerBorderRadius: 0,
          },
        },
      }}
    >
      {isIthClient() ? (
        <>
          <Outlet />
        </>
      ) : (
        <PlmContext.Provider
          value={{
            onProjectChange: (v) => {
              setCurrentProject(v)
            },
          }}
        >
          <div className="fixed top-0 left-0 right-0 h-[55px] z-50 bg-dark-bg grid grid-cols-2 sm:grid-cols-3">
            <div className="h-[55px] flex items-center">
              {currentProject && (
                <a
                  href={documentUtil.getPpmProjectPath(currentProject.id)}
                  className="pl-4 text-[16px] font-bold text-white hover:underline two-line-clamp"
                >
                  {currentProject?.name}
                </a>
              )}
            </div>
            <div className="justify-center sm:flex hidden">
              <div className="w-[230px] h-[55px] pt-[12px]">
                <a
                  href={documentUtil.getPpmPath()}
                  className="block h-[30px] w-full bg-center bg-contain bg-no-repeat"
                  style={{ backgroundImage: `url(${plmLogo})` }}
                >
                  {" "}
                </a>
              </div>
            </div>
            <div className="flex justify-end pr-4">
              {user && (
                <div className="group relative h-full flex items-center font-medium">
                  <div>
                    <img
                      className="h-8 w-8 rounded-full"
                      src={user.avatar}
                      alt=""
                    />
                  </div>
                  <div className="hidden group-hover:block absolute right-0 top-full px-2 py-2 text-left w-32 bg-white shadow-lg ring-1 ring-black/5 rounded">
                    <div className="text-gray-700 text-sm px-2">
                      {user.chineseName}
                    </div>
                    <div
                      onClick={onChangeUser}
                      className="py-2 px-2 text-left text-gray-700 text-sm rounded cursor-pointer flex flex-col gap-2 border-t border-gray-200 mt-2 hover:bg-gray-100 hover:text-gray-900"
                    >
                      切换用户
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <div className="mt-[55px]">
            <Outlet />
          </div>
        </PlmContext.Provider>
      )}
    </ConfigProvider>
  )
}
